import moment from 'moment';

export function getCompletedIn(completed, created) {
    const start = moment(created);
    const end = moment(completed);
    return end.from(start);
  }

export function getDateTimeNow() {
  return moment().format();
}

// TODO: CALL ALL ONE SHOT, BUT TOO SLOW
// export async function loopFunc(callback) {
//   const nowDate = moment().format();
//   const start = moment('2018-04-01');
//   const monthDiff = moment(nowDate).diff(start, 'months');
//   const monthList = [];
  
//   for (let i = monthDiff; i >= 0; i--) {
//     monthList.push(moment(nowDate).subtract(i, 'M').format('YYYYMM'));
//     console.log('for', i);
//   }
//   await Promise.all(monthList.map(async (e) => {
//     console.log('call');
    
//     if (callback) {
//       await callback(e);
//       console.log('e', e); 
//     }
//     console.log('after call');
//   }));
// }


export async function wait(duration) {
  return new Promise(res => setTimeout(res, duration));
}

export function getMonthFromStart() {
  const nowDate = moment().format();
  const start = moment('2018-04-01');
  const monthDiff = moment(nowDate).diff(start, 'months');
  const monthList = [];
  for (let i = monthDiff; i >= 0; i--) { monthList.push(moment(nowDate).subtract(i, 'M').format('YYYYMM')); }
  return monthList;
}

export async function loopFunc(
  callback,
  currentYear = moment().year(),
  currentMonth = (new Date()).getMonth() + 1,
  startYear = 2018,
  startMonth = 3,
) {
  const diffMonths = moment([currentYear, currentMonth]).diff(moment([startYear, startMonth]), 'months', true);
  
  for(var i = 0; i < diffMonths; i ++) {
    const intDate = moment([startYear, startMonth]);
    const addMonths = intDate.add(i, 'months');
    const finalMonths = moment(addMonths).format('YYYYMM');
    if (callback) {
      await callback(finalMonths);
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/time.js